import { useEffect } from "react";
import { Card, CardContent } from "@material-ui/core";
import { compose } from "redux";
import amlConnector from "../../../services/aml/amlConnector";

import "./Aml.scss";

const AmlComponent = ({ amlRules, getAmlRules }) => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(getAmlRules, []);

  return (
    <Card>
      <CardContent>
        {amlRules.data.map((item, index) => {
          return <p key={index}>{item}</p>;
        })}
      </CardContent>
    </Card>
  );
};

export default compose(amlConnector)(AmlComponent);
